import { render } from "./SurgeryFilter.vue?vue&type=template&id=4d1fecfe&scoped=true"
import script from "./SurgeryFilter.vue?vue&type=script&lang=js"
export * from "./SurgeryFilter.vue?vue&type=script&lang=js"

import "./SurgeryFilter.vue?vue&type=style&index=0&id=4d1fecfe&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1fecfe"]])

export default __exports__